import { Component } from '@angular/core';

@Component({
  selector: 'app-combine-pdf-file-free',
  imports: [],
  templateUrl: './combine-pdf-file-free.component.html',
  styleUrl: './combine-pdf-file-free.component.css'
})
export class CombinePdfFileFreeComponent {

}
